import { kebabCase } from 'lodash';

const mapContent = {
  tags: 'availableTags',
  site: 'availableCollections',
  models: 'availableActors',
};

const slugList = ['tags', 'site', 'models', 'gender', 'groups'];
const sortParamList = ['sortby', 'date'];

const getSlugName = (val, key, content) => (
  val.split(',')
    .map((valId) => ({
      id: valId,
      slug: kebabCase(content[key]?.find((v) => Number(v.id) === Number(valId))?.name),
    })).reduce((acc, cur) => ({
      ...acc,
      [cur.id]: cur.slug,
    }), {})
);

export const getSlugs = (filters, content = {}) => {
  let slugs = {};
  filters?.forEach((val, key) => {
    if (slugList.includes(key)) {
      slugs = { ...slugs, ...getSlugName(val, mapContent[key], content) };
    }
  });
  return slugs;
};

export const getRouteObjectFromURLSearchParams = (urlParams, defaultParams) => Array.from(urlParams.entries())
  .filter(([k, v]) => k && ![defaultParams[k], 'undefined'].includes(v))
  .map(([k, v]) => (Array.isArray(v) ? [k, v.join(',')] : [k, v]))
  .reduce((acc, [k, v]) => ({
    ...acc,
    [k]: v,
  }), {});

export const getParamStringFromUrlSearchParams = (urlParams, defaultParams) => {
  const stringParams = new URLSearchParams(urlParams);
  urlParams?.forEach((v, k) => {
    if (defaultParams?.[k] === v) {
      stringParams.delete(k);
    }
  });
  return stringParams.toString();
};

export const getSearchParamsFromDynamicRoute = () => {
  const urlSegments = window.location.pathname.split('/');
  const paramValues = {};
  [...slugList, ...sortParamList].forEach((slug) => {
    const slugIndex = urlSegments.indexOf(slug);
    if (slugIndex > -1) {
      paramValues[slug] = urlSegments[slugIndex + 1];
    }
  });
  return new URLSearchParams({
    ...Object.fromEntries(new URLSearchParams(window?.location?.search || '')),
    ...paramValues,
  });
};
